import type { MatchTeamKit } from "../../types";
import KitColorPicker from "./KitColorPicker";

interface Props {
  value: MatchTeamKit | null | undefined;
  onChange: (next: MatchTeamKit) => void;
  testId: string;
  disabled?: boolean;
}

/**
 * Per-team kit editor for the match wizard (EPIC-113): ONE colour picker
 * (the shirt, stored as `kit.shirt_color`). The sheet word is carried through
 * unchanged. The emitted kit is built explicitly, never spread from the
 * stored one, so legacy shorts/socks are never re-sent.
 */
export default function KitEditor({
  value,
  onChange,
  testId,
  disabled,
}: Props) {
  return (
    <fieldset className="space-y-2" disabled={disabled} data-testid={testId}>
      <div className="flex flex-wrap items-center gap-2">
        {value?.labels?.shirt ? (
          <span className="text-xs text-gray-400">({value.labels.shirt})</span>
        ) : null}
        <KitColorPicker
          value={value?.shirt_color ?? null}
          onChange={(hex) =>
            onChange({
              shirt_color: hex,
              labels: { shirt: value?.labels?.shirt ?? null },
            })
          }
          testId={`${testId}-shirt`}
        />
      </div>
    </fieldset>
  );
}
